export default __webpack_public_path__ + "resources/icons/d342-7ff7.png";